import Loader from 'components/loader'
import { useAuthContext } from 'providers/auth'
import { ReactNode } from 'react'

type Props = {
  state: TYPES.UserState
  children: ReactNode
}

export const ProtectedRoutes = ({ state, children }: Props) => {
  const { isAuthenticated, isInitialized, login } = useAuthContext()

  if (!isInitialized) {
    return <Loader /> // Show a loading indicator while auth is being checked
  }

  if (state === 'unauthenticated') {
    return children // Allow access without authentication
  }

  if (!isAuthenticated) {
    login() // Redirect to login if authentication is required
    return null
  }

  return children
}

export default ProtectedRoutes
